import {useMutation} from 'react-query';
import {deleteChatItem} from '.';
import {AxiosError} from 'axios';
import {toast} from 'react-toastify';
interface IUseDeleteChatItemProps {
  onSuccess?: () => void;
}

interface IPayload {
  guid?: string;
  chatItem?: string;
}
const useDeleteChatItem = ({onSuccess}: IUseDeleteChatItemProps) => {
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: ({guid, chatItem}: IPayload) => {
      return deleteChatItem(guid, chatItem);
    },
    onSuccess: () => {
      onSuccess && onSuccess();
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });
  return {isLoading, mutate, isSuccess};
};

export default useDeleteChatItem;
